import { REQUEST_ARTICLE, RECEIVE_ARTICLE_RESPONSE, RECEIVE_ARTICLE_ERROR, RESET_ARTICLE } from './ArticleAction';

const initialState = {
  isLoadingArticle: false,
  fetchArticleError: false,
  article: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUEST_ARTICLE:
      return {
        ...state,
        isLoadingArticle: true,
      };
    case RECEIVE_ARTICLE_RESPONSE:
      return {
        ...state,
        isLoadingArticle: false,
        article: action.payload,
      };
    case RECEIVE_ARTICLE_ERROR:
      return {
        ...state,
        isLoadingArticle: false,
        fetchArticleError: true,
      };
    case RESET_ARTICLE:
      return {
        ...state,
        article: null,
      };
    default:
      return state;
  }
}
